import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useI18n } from "../../i18n";

const IMAGES = [
  "https://customer-assets.emergentagent.com/job_mediterranean-dawn/artifacts/1xjt49cr_Tavolara.jpg",
  "https://customer-assets.emergentagent.com/job_mediterranean-dawn/artifacts/o97gkn4b_Bici.jpg",
];

export default function Experiences() {
  const { t } = useI18n();
  return (
    <section id="experiences" className="py-24 md:py-36 lg:py-44 px-6 md:px-12 lg:px-20" data-testid="experiences-section">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-12 gap-y-8 mb-14 md:mb-20">
          <div className="col-span-12 md:col-span-6">
            <span className="eyebrow">{t.experiences.eyebrow}</span>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1 }}
              className="font-serif-display text-4xl md:text-5xl lg:text-6xl text-charcoal mt-4 whitespace-pre-line"
              data-testid="experiences-title"
            >
              {t.experiences.title}
            </motion.h2>
          </div>
          <div className="col-span-12 md:col-span-5 md:col-start-8 flex items-end">
            <p className="text-charcoal-soft text-base md:text-lg leading-relaxed">
              {t.experiences.sub}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-12 lg:gap-16 max-w-5xl mx-auto">
          {t.experiences.items.map((exp, i) => (
            <motion.article
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 1, delay: i * 0.15 }}
              className={`group flex flex-col ${i === 1 ? "md:mt-16" : ""}`}
              data-testid={`experience-card-${i}`}
            >
              <div className="relative overflow-hidden aspect-[5/4] bg-sand-200">
                <img
                  src={IMAGES[i]}
                  alt={exp.title}
                  className="w-full h-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.03]"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <div className="mt-5 md:mt-6">
                <h3 className="font-serif text-2xl md:text-3xl text-charcoal leading-tight">
                  {exp.title}
                </h3>
                <p className="mt-3 text-charcoal-soft leading-relaxed max-w-md text-sm md:text-base">
                  {exp.body}
                </p>
                <a
                  href="https://wa.me/393665397779"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`experience-request-${i}`}
                  className="mt-5 inline-flex items-center gap-2 text-xs tracking-luxe uppercase text-charcoal link-elegant"
                >
                  {t.experiences.request}
                  <ArrowUpRight size={14} strokeWidth={1.4} />
                </a>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
